import { TrendingUp, Users, Globe2 } from "lucide-react";

const STATS = [
  { icon: Globe2, value: "+34K", label: "Empresas adoptaron EOS a nivel mundial" },
  { icon: Users, value: "+900", label: "Implementadores certificados globalmente" },
  { icon: TrendingUp, value: "+280K sesiones", label: "en todo el mundo" },
];

export default function StatsBanner() {
  return (
    <section data-testid="stats-banner" className="relative bg-navy-800 text-white overflow-hidden">
      {/* Orange accent stripe */}
      <div className="absolute top-0 inset-x-0 h-[3px] bg-[#F26522]" />
      <div className="absolute bottom-0 inset-x-0 h-[3px] bg-[#F26522]" />
      {/* Subtle pattern */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,1) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />
      {/* Orange glow accent */}
      <div className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-[#F26522] opacity-10 blur-3xl pointer-events-none" />

      <div className="container-eos relative py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-6">
          {STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-item-${i + 1}`}
              className="reveal flex items-start gap-4"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="shrink-0 w-11 h-11 rounded-lg bg-[#F26522] flex items-center justify-center shadow-lg shadow-[#F26522]/20">
                <s.icon className="w-5 h-5 text-white" strokeWidth={1.8} />
              </div>
              <div>
                <p className="font-display font-extrabold text-3xl sm:text-4xl text-white leading-none tracking-tight">
                  {s.value}
                </p>
                <p className="mt-2 text-sm text-slate-300 leading-snug max-w-[180px]">
                  {s.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
